import React from 'react';
import Reflux from 'reflux';
import { Modal, Button, Row, Col } from 'bootstrap';
import AlertActions from 'flux/actions/AlertActions';
import AlertStore from 'flux/stores/AlertStore';
import OnlineIndicatorStore from 'flux/stores/OnlineIndicatorStore';
import AlertTypes from 'shared/constants/AlertTypes';
import { Icon } from '@shoflo-rundown/polymer.legacy';

/**
 * Generic alert
 *
 */
export default React.createClass({
  mixins: [
    Reflux.connect(AlertStore, 'storeState'),
    Reflux.connect(OnlineIndicatorStore, 'onlineIndicator'),
  ],

  displayName: 'Alert',

  render() {
    const isDismissable = this._isDismissable();
    const { onlineIndicator } = this.state;
    const internetConnected = onlineIndicator.get('internetOnline');
    const socketConnected = onlineIndicator.get('socketOnline');

    const isOnline = internetConnected && socketConnected;

    let backdrop = true;
    let keyboard = true;

    if (!isDismissable || !isOnline) {
      backdrop = 'static';
      keyboard = false;
    }

    const children = [this._getHeaderNode(), this._getBodyNode()];

    return (
      <Modal
        autoFocus={false}
        show={this.isVisible()}
        onHide={this._handleClose}
        backdrop={backdrop}
        keyboard={keyboard}
        className="row"
      >
        {children}
      </Modal>
    );
  },

  _getHeaderNode() {
    const isDismissable = this._isDismissable();
    if (this.state.storeState.get('type') === AlertTypes.successAlert) {
      return (
        <Modal.Header key="success-header" closeButton={isDismissable}>
          <h4 className="modal-title success-modal-title">
            <Icon name="check-circle" /> Success!
          </h4>
        </Modal.Header>
      );
    }
    return (
      <Modal.Header key="alert-header" closeButton={isDismissable}>
        <h4 className="modal-title alert-modal-title">
          <Icon name="bell-o" /> Alert
        </h4>
      </Modal.Header>
    );
  },

  _isDismissable() {
    const type = this.state.storeState.get('type');
    return type !== AlertTypes.nondismissableAlert;
  },

  _getBodyNode() {
    const { storeState } = this.state;

    const message = storeState.get('message');

    if (!message) return null;

    let button = null;

    if (this._isDismissable()) {
      button = (
        <Button
          autoFocus
          className="btn-alert-modal center-block"
          onClick={AlertActions.hide}
        >
          {' '}
          OK{' '}
        </Button>
      );
    }

    const buttonNode = (
      <Row>
        <Col lg={24}>{button}</Col>
      </Row>
    );

    return (
      <Modal.Body key="confirm-body">
        <p>{message}</p>
        {buttonNode}
      </Modal.Body>
    );
  },

  _handleClose() {
    AlertActions.hide();
  },

  isVisible() {
    return this.state.storeState.get('message') ? true : false;
  },
});
